import { render, staticRenderFns } from "./Basicd.vue?vue&type=template&id=750d9ec8&scoped=true"
import script from "./Basicd.vue?vue&type=script&lang=js"
export * from "./Basicd.vue?vue&type=script&lang=js"
import style0 from "./Basicd.vue?vue&type=style&index=0&id=750d9ec8&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750d9ec8",
  null
  
)

export default component.exports